import { resourceFromAttributes } from '@opentelemetry/resources';
import { MultiTargetLogRecordProcessor } from '../processor/multi-target-processor';
import { LoggerProvider } from './logger-provider';
let globalLoggerProvider;
export const init = (serviceName, processor) => {
    if (globalLoggerProvider) {
        globalLoggerProvider.diagnosticLogger.error('There was an attempt to reinitialize the global LoggerProvider. Create a secondary instance instead.');
        return;
    }
    globalLoggerProvider = new LoggerProvider({
        resource: resourceFromAttributes({
            'service.name': serviceName,
        }),
        processors: [processor ?? new MultiTargetLogRecordProcessor()],
    });
};
export const getLogger = (name) => {
    if (!globalLoggerProvider) {
        console.warn('The global LoggerProvider was not initialized before creating a logger. ' +
            'Providing a console instance instead');
        return console;
    }
    const logger = globalLoggerProvider.getLogger(name);
    return logger;
};
export const flushLogs = async () => {
    if (globalLoggerProvider) {
        await globalLoggerProvider.forceFlush();
    }
};
export const shutdown = async () => {
    if (globalLoggerProvider) {
        await globalLoggerProvider.shutdown();
        globalLoggerProvider = undefined;
    }
};
//# sourceMappingURL=index.js.map